import React from "react";

const TimeSheet = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M23.3 2H6.733C4.133 2 2 4.158 2 6.788V26.92c0 2.63 2.133 4.788 4.733 4.788h9.434a11.513 11.513 0 01-1.8-6.17c0-.338.033-.675.033-1.012H9.3a1.417 1.417 0 010-2.833h5.733a11.261 11.261 0 011.934-3.439H9.3a1.417 1.417 0 010-2.832h11.1a11.096 11.096 0 015.267-1.316c.8 0 1.6.102 2.366.27V6.788c0-2.63-2.1-4.788-4.733-4.788zm-2.567 10.015H9.3a1.417 1.417 0 010-2.833h11.433a1.417 1.417 0 010 2.833z"
          fill={fill}
      />
      <path className="u_fill"
          d="M25.667 17.14c-4.6 0-8.334 3.777-8.334 8.43S21.067 34 25.667 34 34 30.223 34 25.57s-3.733-8.43-8.333-8.43zm3.666 9.711H24.3V21.66a1.166 1.166 0 112.333 0v2.866h2.7c.634 0 1.167.506 1.167 1.18 0 .64-.5 1.146-1.167 1.146z"
          fill={fill}
      />
    </svg>
);

export default TimeSheet;

